import { render, staticRenderFns } from "./PaymentRequisitionStateCard.vue?vue&type=template&id=a2fda568&"
import script from "./PaymentRequisitionStateCard.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionStateCard.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentRequisitionStateCard.vue?vue&type=style&index=0&id=a2fda568&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports